module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_ES-ac8609d4d8ccdcbd03a767660097f3b4.svg";